// extracted by mini-css-extract-plugin
export var errorInput = "V_cR";
export var errorLabel = "V_cQ";
export var inputContainer = "V_cK";
export var inputNumber = "V_cM";
export var inputPercentage = "V_cN";
export var textInput = "V_cP";
export var textInputDefault = "V_cS";
export var textlabel = "V_cL";